/* eslint-disable jsx-a11y/anchor-is-valid */
import PAText from "component/design-system/typography/PAText/PAText";
import Link from "next/link";
import { createElement } from "react";
import styles from "../accessories-make/accessories-make.module.scss";

function MakeCard(props: any) {
  const { data, labelKey, renderChildren } = props;
  const renderComponent = (each: any) => (
    <Link key={each.url} href={each.url}>
      {renderChildren ? createElement(renderChildren, { ...each }) : <span className={`${styles.subcategory} col-lg-3 col-md-3 col-xs-6`}>{each[labelKey]}</span>}
    </Link>
  );

  const obj = data.reduce((acc, c) => {
    const letter = c.make[0];
    const data = { ...c };
    acc[letter] = (acc[letter] || []).concat(data);
    return acc;
  }, {});

  // `map` over the object entries to return an array of objects
  const updatedData = Object.entries(obj).map(([letter, data]) => ({ letter, data })).sort((a, b) => ((a.letter > b.letter) ? 1 : ((b.letter > a.letter) ? -1 : 0)));

  // {make: 'Nissan Datsun', url: '/nissan-parts', models: undefined}

  return (
    <div className="row m-lr-0">
      {updatedData
        .map((each: any) => (
          <div className="m-t-20 m-b-20">
            <PAText component="h1">
              {each.letter}
            </PAText>
            <div className={styles.each_make}>
              {each.data?.map(((eachData) => renderComponent(eachData)))}
            </div>

          </div>
        ))}
    </div>
  );
}

export default MakeCard;
